import template from './field-type-dropdown.jade';
import './field-type-dropdown.styl';

export default angular.module('cian.addForm.fieldTypeDropdown', []).directive('cianAfHelperFieldTypeDropdown', () => ({
  bindToController: {
    textName: '@',
    inputName: '@',
    inputTitle: '@?',
    inputModel: '=',
    inputModelName: '@',
    items: '=',
    defaultValue: '=?',
    // сообщение
    getCustomMessage: '=?',
    required: '=?',
    invalid: '=?',
    errorMessage: '=?',
    onChange: '@?',
  },
  controller($scope, deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    if (typeof this.getCustomMessage === 'function') {
      $scope.$watch(
        () => this.inputModel,
        viewValue => {
          this.customMessage = this.getCustomMessage(viewValue);
        },
      );
    }
  },
  template,
  controllerAs: 'field',
})).name;
